






import Vue from "vue";

import lineSliceAlong from '@turf/line-slice-along';
import along from '@turf/along';
import length from "@turf/length";
import nearestPointOnLine from "@turf/nearest-point-on-line";
import { GeoJSONSource } from 'mapbox-gl';

import { TripsLayer } from '@deck.gl/geo-layers';
import { MapboxLayer } from '@deck.gl/mapbox';
import { Geometry, Properties, Feature, LineString, Point } from '@turf/helpers';
import { PathLayer } from '@deck.gl/layers'
import distance from '@turf/distance';
import { addLayer, pixelDistance } from '../utils/MapUtils';
import { hexToArray, brandColor, brandColorDark, trackColor, locationColor } from '../utils/Utils';
import { locationStore } from "@/RunnerLocation";

export default Vue.extend({

	inject: ["$map"],
	
	props: {
	},

	data() {
		return {
		}
	},

	computed: {

		location() {
			return locationStore;
		},

		layer():MapboxLayer {
			return this.$map.getLayer('location-track');
		},


		timestamps():number[] {
			//@ts-ignore
			return this.location.history.map((p:GeolocationPosition) => p.timestamp) // eslint-disable-line
		}

	},

	methods: {
		initMap() {
			const layer = new MapboxLayer({
				type: TripsLayer,
				id: "location-track",
				data: [this.location.history as any],
				pickable: false,
				widthUnits: "pixels",
				// widthScale: 20,
				// widthMinPixels: 6,
				getPath: (p:GeolocationPosition[]) => p.map(pos => [pos.coords.longitude, pos.coords.latitude]), // eslint-disable-line
				getTimestamps: (p:GeolocationPosition[]) => p.map(pos => pos.timestamp - p[0].timestamp), // eslint-disable-line
				getColor: f => hexToArray(locationColor()) as any,
				getWidth: 3,
				trailLength: this.location.trackLength,
				rounded: true,
				miterLimit: 1,
				billboard: true,
				currentTime: 1,
				depthTest: false,
			});
			addLayer(this.$map, layer);

			this.drawMap();
		},

		drawMap(){
			this.layer.implementation.setProps({currentTime: this.location.currentTime})
		},

		updateHistory() {
			// console.log(locationStore.history);
			this.drawMap();
			setTimeout(this.updateHistory, 2000);
		}

	},

	watch: {
		"location.currentTime"(){
			this.drawMap();
		},

		"location.history"(){
			this.layer.implementation.setProps({data: [this.location.history]})
			this.drawMap();
		},

	},

	mounted() {
		this.initMap();

		this.updateHistory();

	},
});
